import reducer from "../common";
export default reducer("GET_RESIDENTS", []);
